module.exports = __webpack_public_path__ + "img/IMG_7564.0b1dbfbc.jpeg";